import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { Observable, Observer } from 'rxjs';
import { ConfirmationDialogData } from '../components/modals/confirmation-dialog-data';
import { LanguageService } from '../services/language.service';
import { ConfirmationDialogComponent } from '../components/modals/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<any> {

  constructor(private matDialog: MatDialog, private languageService: LanguageService) {
  }

  canDeactivate(component: any): Observable<boolean> | boolean {
    return new Observable((observer: Observer<boolean>) => {
      if (component.skipConfirmation){
        observer.next(true);
      }
      else if (component.isFormChanged()) {
        const data: ConfirmationDialogData = {
          title: this.languageService.languageJSON.Global_UnsavedDialogTitle,
          message: this.languageService.languageJSON.Global_UnsavedDialogDesc,
          buttons: [this.languageService.languageJSON.Global_Yes, this.languageService.languageJSON.Global_No]
        };

        this.matDialog.open(ConfirmationDialogComponent, { data: { data } }).afterClosed().subscribe((result) => {
          if (result) {
            observer.next(true);
          }
          else {
            observer.next(false);
          }
        });
      }
      else {
        return observer.next(true);
      }
    });
  }
}